export default "__VITE_ASSET__DQopfleF__"